import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Http, Headers, Jsonp } from '@angular/http'; // TODO: migrate to httpClient
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';

// import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import Dexie from 'dexie'

import { ToasterService, Toast } from 'angular2-toaster';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/fromEvent';

import { Observable } from 'rxjs';

const valid_email_re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

@Injectable()
export class DataService {
  YEAR: number = 365 * 24 * 60 * 60 * 1000.0; // in ms !

  BASE_URL: string = "https://philips-dental-pro.appspot.com";
  ADMIN_BASE: string = "https://beta-8-2-admin-dot-dentalshop-de.appspot.com";

  NAMESPACE: string = "PHILIPSDENTALPRO";
  USE_TEST_FORM: boolean = false;
  CONTACT: any;
  LEAD_SRC: string; // (external) newsletter or link partner

  user_info: any; // locally stored user details
  address_complete = false;
  need_order_confirmation = false;
  subuser_info: any;
  is_logged_in: boolean = false;
  reset_params: { email: string; token: string }; // used if reset url was hit

  order_list: any;
  next_order_date: any;
  order_count_1y: number = 0;
  order_value_1y: number = 0;
  order_value_tot: number = 0;

  product_list_first_order: any;
  product_list_normal: any;
  asset_list: any; // cached
  page_content: any; // cached version
  products_to_order: any;
  order_remark: string; // pass in extra remark field with orders
  remarks_by: string; // account manager name
  expo_demo: boolean = false; // check if user has completed the demo the dental expo
  add_marketing: boolean = false;
  order_optin: boolean = false;
  notice = {};        // indexed by lang
  assets_notice = {};

  new_user_email: string;
  new_user_fake_email: string;
  send_order_email: boolean = true;
  need_email_and_phone: boolean = false;

  new_user_firstname: string;
  new_user_lastname: string;
  new_user_phone: string;

  user_token: string = "";
  user_id: string = ""; // the LV activation code
  main_country: string; // wil load from environment
  main_brand: string = "SONICARE"; // or ZOOM set in evironment
  current_language: string = "en";
  currency: string = "EUR";
  locale: string;
  brand: string = "PHILIPS";
  login_header: string;
  send_token_in_request = false;

  // known_languages: string[] = 'nl|fr|en'.split('|');
  known_languages: string[] = "nl|fr".split("|");
  know_countries: any;
  // switch this list after we know the shop URL
  // code is shown in de order page / name is used in the database from powercerv
  // know_countries_BENELUX: any = [
  //   {code: 'NL', name: 'NETHERLANDS'},
  //   {code: 'BE', name: 'BELGIUM'},
  //   {code: 'LU', name: 'LUXEMBOURG'}
  // ];
  // know_countries_DACH: any = [
  //   {code: 'DE', name: 'DE'},
  //   {code: 'AT', name: 'AT'}
  //   // {code: 'CH', name: 'SWISS'}.
  //   // {code: 'A', name: 'AUSTRIA'}
  // ];
  postalcode_len: any = {
    AT: 4,
    DE: 5,
    NETHERLANDS: 4,
    BELGIUM: 5,
    LUXEMBOURG: 4,
    Switzerland: 4,
  };
  tawkto_url: any;
  SERVICE: any;   // holds service email and label for link in footer
  TOS_URL: any;
  TOS_URL_BY_COUNTRY: any;
  INVOICE_BY_EMAIL: any;  // optin for email invoicing

  signup_form: any;     // new client signup form from env

  filter_list = [
    "In chair whitening",
    "In office whitening",
    "Take home whitening",
    "Accessories",
    "Utilities",
  ];
  zoom_guide_available: boolean = true;
  sonicare_available: boolean = true;
  loyalty_available: boolean = false;
  meetings_available: boolean = false;

  assets_available: boolean = true;
  studies_available: boolean = false;
  home_available: boolean = true;
  ftu_available: boolean = true;
  optin_available: boolean = false;
  hide_bulk: boolean = false;

  faq_available: boolean = false;
  contact_footer_available: boolean = false;
  news_available: boolean = false;
  extra_order_button: boolean = false;

  news_count_home = 0;
  max_discount = 0;       // if > 0 we enforce it in the cart
  max_order_value_1y = 0;
  max_order_count_1y = 0;


  allow_register: boolean = true;
  allow_multiple_childs: boolean = true;

  allow_reception: boolean = true;
  allow_students: boolean = true;
  allow_remarks: boolean = false;
  allow_request_account: boolean = false;
  allow_edit_invoice: boolean = false;
  allow_demo_requests: boolean = false;
  allow_demo: boolean = true;
  allow_backorder: boolean = true; // set to false in env of you want o block ordering OOS products
  allow_logo: boolean = false;
  allow_ordering_free_prod: boolean = false;
  need_phone: boolean = true;
  show_orig_total: boolean = false;

  store_parents_locally: boolean = false;
  store_orders_locally: boolean = true;

  need_role: boolean = true;
  show_certified_products: boolean = true;

  shipping_sku: string;
  shipping_costs: number = 0;
  shop_vat_rate: number = 0.21;

  shipping_product: any;
  express_shipping_product: any;

  home_content_blocks: any[];

  pivot_point: number = 0;
  max_first_order_specials: number = 0;

  is_verified: boolean = false;
  xmas: boolean = false;

  we_are_online = true;
  local_db = undefined;
  known_locations = -1; // not counted yet

  onlineStatus: Observable<boolean>;
  offlineStatus: Observable<boolean>;
  admin_storage: Observable<any>;
  order_cache: any;

  // redeem points logic

  redeem_point_sku: number;
  price_per_point: number = -1;
  redeem_point_product: any;
  // loader: any; // no longer needed?

  // edit_profile: boolean = false; // no longer needed?
  // show_shop: boolean = false; // no longer needed?

  constructor(
    public http: Http,
    private jsonp: Jsonp,
    private titleService: Title,
    private router: Router,
    // private onlineStatusService: OnlineStatusService,
    public translate: TranslateService,
    private toasterService: ToasterService
  ) {
    this.onlineStatus = Observable.fromEvent(window, "online");
    this.offlineStatus = Observable.fromEvent(window, "offline");
    this.admin_storage = Observable.fromEvent(window, "storage");

    if (window["brand"]) this.brand = window["brand"];

    // this.know_countries = this.know_countries_BENELUX;

    // NEW method use ENV for each country
    const env_keys = Object.keys(environment);
    for (const key of env_keys) {
      try {
        this[key] = environment[key];
      } catch (e) {
        console.warn(
          `was not able to set dataservice.${key} = ${environment[key]}`
        );
      }
    }
    this.set_language(this.current_language);

    if (
      !!window.location &&
      !!window.location.hostname &&
      (window.location.hostname.startsWith("dev") ||
        window.location.hostname == "localhost")
    ) {
      if (
        window.location.port == "4300" ||
        window.location.search == "?local"
      ) {
        this.NAMESPACE = environment["LOCAL_NAMESPACE"];
        this.BASE_URL = environment["LOCAL_BASE_URL"];
      } else {
        // this.NAMESPACE = environment['LOCAL_NAMESPACE'];
        // this.BASE_URL = environment['LOCAL_BASE_URL'];
        this.NAMESPACE = environment["DEV_NAMESPACE"];
        this.BASE_URL = environment["DEV_BASE_URL"];
      }
      console.log("DEV url detected current ns = " + this.NAMESPACE);
      console.log("new ns = " + this.NAMESPACE);
    }

    if (!!window.location && !!window.location.search) {
      // handle NS and API mods from the URL querystring

      let qs = window.location.search;
      if (!!qs && qs.startsWith("?")) {
        let params = window.location.search.split("?")[1].split("&");
        for (let kv of params) {
          let key_val = kv.split("=");
          if (key_val[0] == "ns" && !!key_val[1]) {
            this.NAMESPACE = key_val[1];
            this.USE_TEST_FORM = true;
          }
          if (key_val[0] == "base" && !!key_val[1]) {
            this.BASE_URL = key_val[1];
          }
          if (key_val[0] == "src" && !!key_val[1]) {
            this.LEAD_SRC = key_val[1];
            try {
              // remember it
              window.localStorage.setItem('LEAD_SRC', this.LEAD_SRC);
            } catch (e) {

            }
          }
        }
        if (this.NAMESPACE == "TST" && this.currency != "AUD") {
          this.BASE_URL = "http://localhost:8877";
          this.USE_TEST_FORM = true;
        }
      }
    }
    // if (this.brand == 'ABB') {
    //   this.current_language = 'nl';
    //   this.known_languages = ['nl'];
    //   this.set_language('nl');
    //   this.NAMESPACE = 'ABB';
    //   if (window.location.hostname.startsWith('dev')) this.NAMESPACE += '-TST';
    //   if (window.location.hostname.startsWith('dev')) this.NAMESPACE += '-TST';
    //   this.BASE_URL = 'https://bush-jaeger.appspot.com';
    //   // this.BASE_URL = 'http://localhost:8877';
    //   console.log('new ns = ' + this.NAMESPACE);
    //   this.zoom_guide_available = false;
    //   this.sonicare_available = false;
    //   this.assets_available = false;
    //   this.ftu_available = false;
    //   this.home_available = false;
    //   this.need_role = false;
    //   this.allow_reception = false;
    //   this.allow_students = false;
    // }

    this.set_language(this.translate.currentLang);
    this.admin_storage.subscribe(event => {
      console.log(event.key);
      if (event.key == 'admin_products') {
        let updated_json = event.newValue;
        let updated_products = JSON.parse(updated_json);
        this.process_products(updated_products, false);
      }
    });
    this.offlineStatus.subscribe((offline) => {
      this.we_are_online = !offline;
    });
    this.onlineStatus.subscribe((online) => {
      this.we_are_online = !!online;
      if (!!this.we_are_online) {
        this.resend_pending_orders();
      }
    });

    if (!this.LEAD_SRC) {
      try {
        this.LEAD_SRC = window.localStorage.getItem('LEAD_SRC');
      } catch (e) { };
    }
    this.initDatabase();
    this.count_locations();
    this.count_orders();
  }

  private initDatabase() {
    this.local_db = new Dexie("dentalshop");
    this.local_db.version(1).stores({
      locations: "id, company, postalcode, ext_id", // this are indexes
      orders: "++id, status",
    });
    if (this.we_are_online) {
      this.resend_pending_orders();
    }
  }

  count_locations() {
    this.local_db.locations
      .count()
      .then((cnt) => {
        this.known_locations = cnt;
      })
      .catch((err) => {
        this.known_locations = -2;
        console.warn(err);
      });
  }

  count_orders() {
    this.local_db.orders.toArray().then((all_orders) => {
      this.order_cache = {};
      for (const local_order of all_orders) {
        if (!!local_order.order.remark.am) {
          if (!this.order_cache[local_order.order.remark.am]) {
            this.order_cache[local_order.order.remark.am] = [];
          }
          this.order_cache[local_order.order.remark.am].push(local_order.order);
        }
      }
    });
  }

  is_valid_email(email) {
    return !!email && valid_email_re.test(email);
  }

  cripple_email(email) {
    let remail = email.replace("@", "_at_").replace(/\./g, "_dot_");
    const rnd = Math.trunc(Math.random() * 10000);
    return `${remail}__REMOVE__${rnd}@example.com`;
    // return 'noreply@example.com';
  }

  generate_fake_email(firstname, lastname, parent) {
    const rnd = Math.trunc(Math.random() * 10000);
    return `${firstname}.${lastname}.${parent}.${rnd}@example.com`;
    // return 'noreply@example.com';
  }

  get_language() {
    this.current_language = this.translate.currentLang;
    return this.current_language;
  }

  get_user_country_code() {
    let cc = this.main_country
    if (!!this.user_info.country) {
      let raw_country = this.user_info.country.toUpperCase();
      let potental_countries = this.know_countries.filter((cinfo) => {
        if (!!cinfo.code && cinfo.code === raw_country) return cinfo;
        if (!!cinfo.name && cinfo.name === raw_country) return cinfo;
        // alt spellings may be includes in the cinfo in the ENV
        if (!!cinfo.alts && cinfo.alts.length > 0 && cinfo.alts.indexOf(raw_country) > -1) return cinfo;
      });
      if (!!potental_countries && potental_countries.length === 1) {
        cc = potental_countries[0].code;
      }
    }
    return cc;
  }

  get_TOS_url() {
    if (!!this.TOS_URL_BY_COUNTRY) {
      const CC = this.get_user_country_code();
      const CTOS_URL = this.TOS_URL_BY_COUNTRY[CC];
      if (!!CTOS_URL) {
        return CTOS_URL[this.current_language];
      }
    }
    else if (!!this.TOS_URL) {
      return this.TOS_URL[this.current_language];
    }
    return undefined;
  }
  set_translated_title() {
    if (this.brand == "ABB") return;

    this.translate.get("Tandheelkundigen").subscribe((loc_title) => {
      let translated_title = loc_title + " - Philips";
      this.titleService.setTitle(translated_title);
    });
  }

  set_language(lng: string) {
    if (!!this.known_languages && this.known_languages.indexOf(lng) == -1)
      return; // ignore unknown languages
    if (this.current_language == lng) return; // no change   
    this.translate.use(lng);
    this.current_language = lng;
    this.locale = this.current_language;
    if (this.main_country != "NL") {
      this.locale = `${lng}-${this.main_country}`;
      if (this.main_country == "CH") {
        // fr-CH uses comma;s en spaces, philips uses the de-CH markup also for french version of the site
        this.locale = `de-CH`;
      }
    }

    console.log("locate set to " + this.locale);

    try {
      window["hj"]("trigger", "show_exit_poll_" + this.current_language);
    } catch (e) { }
    this.set_translated_title();

    // TODO we should try to get the country we are in from the browser ?
    try {
      window['eddlContext']['locale'] = {
        country: lng == 'fr' ? 'be' : 'nl', //ISO 3166-1 alpha-2 country code
        language: lng, //ISO 639-1 language code
        currency: 'EUR', //ISO 4217 curreccy code
        code: lng == 'fr' ? 'fr_BE' : 'nl_NL' //language in lower case + country in upper case
      }
    } catch (locale_err) {
      console.warn(locale_err);
    }
    // trigger a new page view in the new language
    this.virtual_pageview(window['location']['pathname']);
  }

  change_user_language(lng_str) {
    const new_lang = lng_str.toLowerCase();
    this.set_language(new_lang);
    // show hide the chat widget ...
    if (this.current_language == "nl") {
      try {
        window.document.getElementById("launcher").style.display = "block";
      } catch (e) { }
    } else {
      try {
        window.document.getElementById("launcher").style.display = "none";
      } catch (e) { }
    }
  }

  loadUserDetails() {
    // this.user_id = window.localStorage.getItem('LC_REGISTERED_USER_ID'); Deprecated?
    // only do this if we DON'T already have a user locally.
    if (!!this.subuser_info) {
      // english version will not listen to user lang preference
      if (!!this.subuser_info && !!this.subuser_info.language) {
        this.set_language(this.subuser_info.language.toLowerCase());
      } else {
        if (!!this.user_info && !!this.user_info.language) {
          this.set_language(this.user_info.language.toLowerCase());
        }
      }
    } else {
      // Only update parent user, subuser comes from localstorage. Thats fine.
      try {
        this.subuser_info = JSON.parse(
          window.localStorage.getItem("user_info")
        );
      } catch (e) {
        // data in local storage seems corrupted ?
        this.subuser_info = undefined;
        window.localStorage.removeItem("user_info");
      }
      // parent user should be updated! Else we have different loyalty points on different pages.
      if (!!this.subuser_info) {
        if (this.loyalty_available && this.subuser_info.optin_loyalty == undefined) {
          this.subuser_info.optin_loyalty = true;
        }
        this.getUserForCode(this.subuser_info.parent).subscribe(
          (parent_user) => {
            console.log(parent_user);
            if (!!parent_user) {
              if (
                !!parent_user.loyalty_balance &&
                parent_user.loyalty_balance < 0
              ) {
                parent_user.loyalty_balance = 0;
              }
              this.user_info = parent_user;
              if (!this.show_certified_products) {
                // TEMP hide all certified products for all users
                this.user_info.is_certified = false;
              }
              window.localStorage.setItem(
                "parent_info",
                JSON.stringify(this.user_info)
              );
            }
          }
        );
      }
    }
  }

  tryLogin() {
    const refresh_token = window.localStorage.getItem("user_refresh_token");
    if (!!refresh_token) {
      let tt = atob(refresh_token).split("::");
      if (!!tt && tt.length === 2) {
        // this.login(tt[0], tt[1])
        return tt;
      } else {
        this.is_logged_in = false;
        return undefined;
      }
    } else {
      return undefined;
    }

    // let token = window.localStorage.getItem('user_token');
    // let valid = window.localStorage.getItem('user_token_valid_until');
    // let token_is_valid = false;
    // if (!!token && !!valid){
    //   let now = new Date();
    //   let valid_date = new Date(valid);
    //   token_is_valid = valid_date > now;
    // }
    //
    // if (token_is_valid){
    //   this.loadUserDetails(); // load up info, if available
    //   // this.ngOnChanges();
    //   this.is_logged_in = true;
    // } else {
    //   let refresh_token = window.localStorage.getItem('user_refresh_token');
    //   if( !!refresh_token ){
    //     // try{
    //       let tt = atob(refresh_token).split('::');
    //       if (!!tt && tt.length === 2) this.login(tt[0], tt[1]);
    //       else {
    //         this.is_logged_in = false;
    //       }
    //     // }
    //     // catch (e){
    //     //   console.log('auto login failed: ' + e);
    //     // }
    //   }
    //
    // }
  }

  saveUserInfo(user) {
    this.subuser_info = user;

    if (!!this.subuser_info && !this.subuser_info.verified) return;

    if (!!this.subuser_info && !!this.subuser_info.language) {
      this.set_language(this.subuser_info.language.toLowerCase());
    }

    //window.localStorage.setItem('remember_me',JSON.stringify(true) );

    // write entire client info to storage
    window.localStorage.setItem("user_info", JSON.stringify(this.subuser_info));

    //  set user_id to localstorage
    // window.localStorage.setItem('LC_REGISTERED_USER_ID', this.subuser_info);  // WHY do we store this twice ??

    if (!!this.user_info)
      window.localStorage.setItem(
        "parent_info",
        JSON.stringify(this.user_info)
      );
  }

  forgetUserInfo() {
    this.user_info = undefined;
    this.subuser_info = undefined;
    this.user_id = undefined;
    this.order_list = undefined;
    this.order_value_1y = 0;
    this.order_value_tot = 0;
    this.order_count_1y = 0;
    this.next_order_date = undefined;

    // this.edit_profile = false;
    // this.show_shop = false;

    // clear client info in  storage
    window.localStorage.removeItem("user_token");
    window.localStorage.removeItem("user_refresh_token");

    window.localStorage.removeItem("user_token_valid_until");
    window.localStorage.removeItem("parent_info");
    window.localStorage.removeItem("user_info");
    // window.localStorage.removeItem('LC_REGISTERED_USER_ID');  // WHY do we store this twice ??
  }

  allow_VAT_number() {
    let allow = false;

    if (!!this.user_info && !!this.user_info["country"]) {
      allow =
        this.user_info["country"].toLowerCase().startsWith("bel") ||
        this.user_info["country"].toLowerCase().startsWith("lux");
    }
    return allow;
  }

  send_backup(orderlist) {
    let headers = new Headers({ "x-auth": "110011" });
    let backup_url = this.ADMIN_BASE + "/api/" + this.NAMESPACE + "/backup";

    return this.http
      .post(backup_url, JSON.stringify(orderlist), { headers: headers })
      .map((res) => res.json())
      .catch((error) => {
        let error_details = error;
        return Observable.throw(error_details);
      })
      .share();
  }

  // sub_users (email based) ...
  create_user(user_info) {
    let headers = new Headers({ "x-auth": this.user_info.id });
    let signup_url = this.BASE_URL + "/api/" + this.NAMESPACE + "/signup";

    return this.http
      .post(signup_url, JSON.stringify(user_info), { headers: headers })
      .map((res) => res.json())
      .catch((error) => {
        let error_details = error;
        return Observable.throw(error_details);
      })
      .share();
  }

  // TODO: IMPLEMENT THIS WITH A PUT?
  update_user(user_info) {
    let headers = new Headers({});
    let user_id;
    let resource = 'subuser';
    if (!!this.subuser_info && !!this.subuser_info.token) {
      headers.append("authorization", "Bearer " + this.subuser_info.token);
    }
    if (!!this.subuser_info) {
      if (!this.subuser_info.id || this.subuser_info.id === 'undefined' || this.subuser_info.id === 'None' || this.subuser_info.id === '') {
        this.subuser_info.id = this.subuser_info.user_id;
      }
      if (!!this.subuser_info.id && !this.subuser_info.user_id) {
        this.subuser_info.user_id = this.subuser_info.id;
      }
      user_id = this.subuser_info.id;
    }
    // handle unsubscribe requests
    if (!!user_info.id && !!user_info.h && !!user_info.r) {
      user_id = user_info.id;
      resource = 'optout_subuser';  // add resource mod
    }

    let update_url = `${this.BASE_URL}/api/${this.NAMESPACE}/${resource}/${user_id}`;

    return this.http
      .put(update_url, JSON.stringify(user_info), { headers: headers })
      .map((res) => {
        this.saveUserInfo(res.json());
        return res.json();
      })
      .catch((error) => {
        let error_details = error;
        return Observable.throw(error_details);
      })
      .share();
  }

  verify_user(uid, token) {
    let resource = "verify/signup"
    let verify_url = `${this.BASE_URL}/api/${this.NAMESPACE}/${resource}/${uid}/${token}`;

    return this.http
      .get(verify_url)
      .map((res) => res.json())
      .catch((error) => {
        let error_details = error;
        return Observable.throw(error_details);
      })
      .share();
  }

  resend_email(email) {
    let user_info = { email: email.toLowerCase() };
    let resend_url = this.BASE_URL + "/api/" + this.NAMESPACE + "/resend";

    return this.http
      .post(resend_url, JSON.stringify(user_info))
      .map((res) => res.json())
      .catch((error) => {
        let error_details = error;
        return Observable.throw(error_details);
      })
      .share();
  }

  reset_password(reset_data) {
    let reset_url = this.BASE_URL + "/api/" + this.NAMESPACE + "/reset";

    return this.http
      .post(reset_url, JSON.stringify(reset_data))
      .map((res) => res.json())
      .catch((error) => {
        let error_details = error;
        return Observable.throw(error_details);
      })
      .share();
  }

  forgot_password(email) {
    let user_info = { email: email.toLowerCase() };
    let login_url = this.BASE_URL + "/api/" + this.NAMESPACE + "/forgot";

    return this.http
      .post(login_url, JSON.stringify(user_info))
      .map((res) => res.json())
      .catch((error) => {
        let error_details = error;
        return Observable.throw(error_details);
      })
      .share();
  }

  subscribe_to_list(list_id) {
    let url = "https://belowenemylines.createsend.com" + list_id;
    url +=
      "?cm-name=" +
      encodeURIComponent(
        this.subuser_info.first_name + " " + this.subuser_info.last_name
      );
    url += "&cm-fuhydk-fuhydk=" + encodeURIComponent(this.subuser_info.email);

    // NOTE: this should work like this ....
    // return this.jsonp.request(url+'&callback=JSONP_CALLBACK').map(res => res.json());

    return this.jsonp
      .request(url + "&callback=__ng_jsonp__.__req0.finished")
      .map((res) => res.json());
  }

  receive_extra_vouchers(list_id) {
    let url = "https://belowenemylines.createsend.com" + list_id;
    url += "?cm-name=" + encodeURIComponent(this.user_info.invoice_company);
    url +=
      "&cm-f-jliykyi=" +
      encodeURIComponent(this.user_info.city + ", " + this.user_info.address);
    url += "&cm-f-jliykyd=" + encodeURIComponent(this.user_info.ext_id);
    url += "&cm-vjiihr-vjiihr=" + encodeURIComponent(this.subuser_info.email);

    // NOTE: this should work like this ....
    // return this.jsonp.request(url+'&callback=JSONP_CALLBACK').map(res => res.json());

    return this.jsonp
      .request(url + "&callback=__ng_jsonp__.__req0.finished")
      .map((res) => res.json());
  }

  login(email, password) {
    let user_info = {
      email: email.toLowerCase(),
      password: password,
      parent: this.user_id,
    };
    let login_url = this.BASE_URL + "/api/" + this.NAMESPACE + "/login";

    return this.http
      .post(login_url, JSON.stringify(user_info))
      .map(
        (res) => {
          let user = res.json();

          if (!!user.parent) {
            this.getUserForCode(user.parent).subscribe((user_info) => {
              if (
                !!user_info.loyalty_balance &&
                user_info.loyalty_balance < 0
              ) {
                user_info.loyalty_balance = 0;
              }
              this.user_info = user_info;
              if (!!this.user_info) {
                window.localStorage.setItem(
                  "parent_info",
                  JSON.stringify(this.user_info)
                );
              }
            });
          }
          return user;
        },
        { withCredentials: false }
      )
      .catch((error) => {
        let error_details = error;
        return Observable.throw(error_details);
      })
      .share();
  }

  logout() {
    this.forgetUserInfo(); // ?? why not ??
    return this.get("logout").map((res) => res.json());
  }

  get_unconfirmed(action, id: string) {
    return this.get(`${action}/${id}`).map((res) => res.json());
  }

  // parent user (code based) handling ...
  getUserForCode(code) {
    let user_url = this.BASE_URL + "/api/" + this.NAMESPACE + "/user/" + code;
    return this.http
      .get(user_url)
      .map((res) => {
        let user = res.json();
        if (!!user && user.country == "Luxembourg") {
          this.loyalty_available = false;
        }
        // correct for  placeholders ...
        if (!!user.address)
          user.address = user.address.replace("new address", "");
        if (!!user.city) user.city = user.city.replace("CITY", "") || "";
        if (!!user.postalcode)
          user.postalcode = user.postalcode.replace("12345", "") || "";

        if (!user.has_other_invoice_address) {
          user.invoice_company = user.company;
          user.invoice_address = user.address;
          user.invoice_city = user.city;
          user.invoice_postalcode = user.postalcode;
        }
        user.is_premium_partner = !!user.premium_partner_type;
        if (!!user.premium_partner_until) {
          user.is_premium_partner = new Date(user.premium_partner_until) > new Date();
        }
        return user;
      })
      .share();
  }

  getUsersForPostalcodeAlt(postalcode: string, country: string) {
    const base = 'https://docs.google.com/spreadsheets/d';
    // TODO select sheet by country
    const sheet_id = '1bQK-7P7gQ9yDoAp8n81tIjEHX0AqOvuZ5rgfqO2Vhlo';
    const q = encodeURIComponent(`where K starts with ${postalcode}`);
    const user_url = `${base}/${sheet_id}/gviz/tq?tq=${q}`;
    debugger;
    return this.http
      .get(user_url)
      .map((res) => {
        const rel_data = res.text().split('.setResponse(')[1].split(');')[0];
        const payload = JSON.parse(rel_data);
        if (payload.status === 'ok') {
          const table = payload.table.rows;
          const users = table.map(r => r.c.map(x => !!x && x.v)).map(u => ({
            type: u[0],
            ext_id: u[1],
            company: u[2],
            address: u[3],
            city: u[7],
            postalcode: u[10],
            status: u[12]
          }));
          return users.filter(x => x.status === 'Active');
        }
      })
      .catch((e) => {
        console.warn(e);
        return Observable.of([]);
      });
  }

  // parent user (code based) handling ...
  getUsersForPostalcode(postalcode: string, country: string) {

    // return this.getUsersForPostalcodeAlt(postalcode, country);

    let start_code;
    if (["de", "es"].indexOf(this.current_language) > -1) {
      // start_code = Number(postalcode).toString(); // DO NOT ignore leading zero's
      start_code = postalcode.slice(0, 5); // FIRST 5 !!
    } else {
      start_code = postalcode.slice(0, 4); // FIRST 4
    }
    let end_code = (parseInt(start_code) + 1).toString();
    if (start_code[0] == "0") {
      end_code = "0" + end_code;
    }
    let local_locations = this.local_db.locations
      .where("postalcode")
      .startsWith(start_code)
      .and((loc) => loc.country == country)
      .toArray();

    if (!this.we_are_online || this.known_locations > 100) {
      return Observable.fromPromise(local_locations);
    }

    // let user_url = `${this.BASE_URL}/api/${this.NAMESPACE}/user?country=${country}&pc_start=${start_code}&pc_end=${end_code}`;
    // let user_url = `${this.BASE_URL}/api/${this.NAMESPACE}/user?country=${country}&zip=${start_code}`; // this will trigger remote (PowerCerv) search by ZIP

    let user_url = `${this.BASE_URL}/api/${this.NAMESPACE}/user?zip=${start_code}&country=${country}`; // this will trigger remote (PowerCerv) search by ZIP

    let headers = new Headers();
    headers.append("X-Auth", "VjKTfhDy90OB6IFXMQSO-c5Rtk8PSgzxhkWI5Nqpa");

    if (start_code == "TSV") {
      return this.http
        .get(user_url, { headers: headers })
        .map((res) => res.text());
    }

    let remote_locations = this.http
      .get(user_url, { headers: headers })
      .map((res) => {
        let users = res.json();
        return users;
      })
      .catch((e) => {
        console.warn(e);
        return Observable.of([]);
      });

    // TODO: we would like to search remote only of teh local results are empty, saving on expensive api calls here ...
    return Observable.forkJoin([
      Observable.fromPromise(local_locations),
      remote_locations,
    ]).map(([local_results, remote_results]) => {
      let locs = {};
      // merge to we get one item per uniq id using the hash table trick
      for (let loc of local_results) {
        locs[loc.id] = loc;
      }
      for (let rm_loc of remote_results) {
        if (!rm_loc.id && !!rm_loc.ext_id) {
          rm_loc.id = rm_loc.ext_id;
        }
        // remote items are fresher so we may override the local version
        locs[rm_loc.id] = rm_loc;
      }
      const values = Object.keys(locs).map((key) => locs[key]);
      return values;
    });
  }

  // NOTE the user can only be change the invoice_ fields ....
  updateUserInfo(user_info) {
    if (!user_info.id) {
      user_info.id = this.user_info.id;
    }
    let headers = new Headers({});
    if (!!user_info) {
      headers.append("x-auth", user_info.id);
    } else {
      if (!!this.subuser_info && !!this.subuser_info.parent) {
        headers.append("x-auth", this.subuser_info.parent);
      }
    }
    if (!!this.subuser_info && !!this.subuser_info.token) {
      headers.append("authorization", "Bearer " + this.subuser_info.token);
    }
    // let put_headers = new Headers({ 'x-auth': user_info.id });

    let user_url =
      this.BASE_URL + "/api/" + this.NAMESPACE + "/user/" + user_info.id;
    console.log("putting this user: ", user_info);

    if (user_info.status == "LEAD") {
      user_info.status = "CONFIRMED_LEAD";
    } else {
      user_info.has_other_invoice_address = true;
    }

    let payload = { ...user_info };
    delete payload.sub_users;  // you cannot write this attr


    return this.http
      .put(user_url, JSON.stringify(payload), { headers: headers })
      .map((res) => res.json());
  }

  getSingleProduct(product_id) {
    // no need to login ?
    let request_url =
      this.BASE_URL + "/api/" + this.NAMESPACE + "/product/" + product_id;
    return this.http.get(request_url).map((res) => res.json());
  }

  cert_from_product(p) {
    // TODO: remove this
    try {
      // TODO: this is temp until data is correct in backend
      if (p.id.indexOf("Z") == 0) return "ZOOM";

      if (p.id.indexOf("ACTIE-Z") == 0) return "ZOOM";
      if (p.id.indexOf("ACTIE.Z") == 0) return "ZOOM";

      if (p.id.indexOf("ACTIE1-Z") == 0) return "ZOOM";
      if (p.id.indexOf("ACTIE1.Z") == 0) return "ZOOM";
    } catch (e) { }
    return undefined;
  }

  _translate_attr(obj, att_name) {
    let lng_mod = "_" + this.current_language.toUpperCase();
    if (!!obj[att_name + lng_mod]) obj[att_name] = obj[att_name + lng_mod];
  }

  _translate_object(obj) {
    let lng_mod = "_" + this.current_language.toUpperCase();
    for (let att_name in obj) {
      att_name = att_name.split(lng_mod)[0];
      if (!!obj[att_name + lng_mod]) obj[att_name] = obj[att_name + lng_mod];
    }
    return obj;
  }

  translate_list(list) {
    for (let item of list) {
      this._translate_object(item);
    }
  }

  get_last_order_date(p) {
    let last_order_date = new Date(0); // very long time ago ...
    for (const order of this.order_list) {
      for (const item of order.items) {
        if (item.product_details.id === p.id) {
          if (order.created_datetime > last_order_date) last_order_date = order.created_datetime;
        }
      }
    }
    return last_order_date;
  }

  process_products(list, allow_first_order_special) {
    // TODO: more product data processing and translations
    let allowed = [];
    let top_specials = [];
    let premium = undefined;
    if (!!this.user_info && this.user_info.is_premium_partner) {
      premium = this.user_info.premium_partner_type;
    }

    // user country based pricing for germany
    if (
      this.main_country === "DE" &&
      !!this.user_info &&
      !!this.user_info.country
    ) {
      premium = this.user_info.country;
    }

    // let marketing_allowed = !!this.user_info && !!this.user_info.marketing_allowed;
    let marketing_allowed = true;

    for (let p of list) {
      // TODO: check the logic of this line ...
      if (p.base_price == undefined) p.base_price = 0; //continue;

      if (
        p.id == "VOUCHER" &&
        !!this.user_info &&
        this.user_info.country != "Netherlands"
      ) {
        p.status = "AVAILABLE";
        // if( this.loyalty_available ){
        //   p.status = 'AVAILABLE';
        // } else {
        //   p.status = "DELETED";
        // }
      }
      p.is_asset = false;
      if (p.status == "ASSET") continue; // assets have their own logic now !
      if (p.status == "STUDY") continue; // assets have their own logic now !

      p.tresholds = [];
      for (let min_count in p.price_from_unit_count) {
        if (parseInt(min_count) > 1) p.tresholds.push(min_count);
      }

      // TRY TO SET A default PROD IMAGE
      // p.images = [];
      if (!p.images || p.images.length == 0) {
        let img_name = p.ext_id || p.SKU || p.id;
        if (!!img_name) {
          img_name = "/assets/PROD/" + img_name.toString().replace("/", "_") + ".jpg";
          p.images = [img_name];
        }
      }

      if (!p.filters) p.filters = [];

      p.order_amount = 0;
      // fix missing unit counts !
      if (!p.unit_count) p.unit_count = 1;

      if (!p.orig_price || p.orig_price < p.base_price) {
        p.orig_price = p.base_price; // make sure we have a correct base price !
      }

      if (!!p.status) {
        if (!this.remarks_by) {
          p.is_hidden = p.status.indexOf("HIDDEN") > -1;
        }
        if (p.status == "REDEEM_POINT") {
          p.is_hidden = true;
        }
      }

      if (!!p.status && p.status.indexOf("SPECIAL") > -1) {
        if (p.status.indexOf("STICKY") > -1) {
          p.is_sticky = true;
          p.is_hidden = true;
        } else {
          if (p.status.indexOf("_TOTALCART_") > -1) {
            p.is_cart_special = true;
            p.is_hidden = true;
            let discount = p.status.split('_')[2];
            p.total_discount = Number(discount);
            p.order = -100; // at the end please 
          } else {
            p.is_special = true;
            if (!!p.order) {
              p.order += 10000; // all specials on top in the orig order please
            }
          }
        }

        // extract more info about the type of GROUPED specials
        // special type X+F order X get F for free (need to add X+F in basket)
        //                  the reduction is for F leasts expensive products

        // AU special wish
        // 3+2 
        // 5+3 
        // 7+5 
        // 10+7
        //
        // SPECIAL_STDPEN_3|5|7|10+2|3|5|7[881070211530]

        // hard codes special over rides for AU
        if (p.status == 'SPECIAL_STDPEN_3+2[881070211530]') {
          p.status = 'SPECIAL_STDPEN_3|5|7|10+2|3|5|7[881070211530]'
        }
        let special_parts = p.status.split("[")[0].split("_");
        if (special_parts.length == 3) {
          p.special_group = special_parts[1];
          p.special_type = special_parts[2];
          p.special_free_max = 99;

          if (p.special_type.indexOf("+.") > -1) {
            // looks like grouped bulk discounts
            let sp_bulk_steps = p.special_type.split("/");
            p.special_bulk_discount = {};
            for (const step of sp_bulk_steps) {
              const from_amount_discount = step.split("+");
              const from_amount = parseInt(from_amount_discount[0]);
              const discount = parseFloat(from_amount_discount[1]);
              p.special_bulk_discount[from_amount] = discount;
              if (!p.special_needed) p.special_needed = from_amount;
              p.special_needed = Math.min(from_amount, p.special_needed);
            }
          } else {
            let sp_type_parts = p.special_type.split("+");
            if (sp_type_parts.length == 2) {
              if (p.status.indexOf("[")) {
                sp_type_parts[1] += "[" + p.status.split("[")[1];
              }
              let free_count, free_id, free_max;
              try {
                [free_count, free_id] = sp_type_parts[1].split("[");
                if (free_id.split("]").length > 0) {
                  free_max = free_id.split("]")[1];
                }
                free_id = free_id.split("]")[0];
              } catch (e) {
                [free_count, free_id] = [sp_type_parts[1], null];
              }

              p.special_min = parseInt(sp_type_parts[0]);
              p.special_free = parseInt(free_count);
              try {
                if (sp_type_parts[0].indexOf('|') > -1) {
                  p.special_min_array = sp_type_parts[0].split('|');
                  p.special_free_array = free_count.split('|');
                  p.special_free_max = parseInt(p.special_free_array.slice(-1)[0]);
                }
              } catch (e) { };
              p.special_free_pid = free_id;
              if (!!free_max) {
                p.special_free_max = parseInt(free_max);
              }
              p.special_needed = p.special_min + p.special_free;
            }
            if (sp_type_parts.length == 1) {
              p.special_min = parseInt(sp_type_parts[0]);
              p.special_needed = p.special_min;
            }
          }
        }
        if (!!p.available_until) {
          try {
            let date_parts = p.available_until.split("-");
            p.available_until_eur =
              date_parts[2] + "-" + date_parts[1] + "-" + date_parts[0];
          } catch (e) {
            p.available_until_eur = p.available_until;
          }
        }
      } else {
        p.is_special = false;
        p.available_until = undefined;
      }

      if (p.max_points_allowed > 0) {
        // p.is_special = true; // DO NOT LIST AS SPECIAL !
        // if( !p.tag ){
        //   p.tag = `** ${p.max_points_allowed} **`;
        // }
        // this.loyalty_available = true;
        if (!!this.user_info && this.user_info.country == "Luxembourg") {
          this.loyalty_available = false; // sorry ...
        }
      }

      if (!p.base_price) p.base_price = 0;

      if (p.base_price == 0) {
        if (!p.max_units) p.max_units = 1; // can override default of 1
        if (!this.allow_ordering_free_prod) p.needs_paid_product = true;
      } else {
        if (
          p.max_units === undefined ||
          p.max_units === null ||
          p.max_units === ""
        )
          p.max_units = 9999;
        p.needs_paid_product = false;
      }

      // check if the product can be ordered again
      if (!!p.min_weeks_between_orders && p.min_weeks_between_orders > 0) {

        let min_days_between_orders = 7 * Number(p.min_weeks_between_orders);
        let last_order_date = this.get_last_order_date(p);
        let order_age = (new Date().valueOf() - last_order_date.valueOf()) / (24 * 60 * 60 * 1000); // in days 

        if (order_age < min_days_between_orders) {
          p.max_units = 0;
          p.next_order_date = new Date();
          p.next_order_date.setDate(p.next_order_date.getDate() + (min_days_between_orders - order_age));
        }
      }

      if (p.status == "FIRSTORDER_SPECIAL") {
        if (allow_first_order_special) {
          this.max_first_order_specials = p.max_units;
          p.is_special = true;
          top_specials.push(p);
        } else {
          p.status = "AVAILABLE";
          p.max_units = 99999;
          p.base_price = p.orig_price;
          if (!!p.price_from_unit_count && !!p.price_from_unit_count["1"]) {
            p.price_from_unit_count["1"] = p.base_price;
          }
          p.orig_price = undefined;
          p.is_special = false;
          p.tag = ""; // ??
          p.tag_NL = "";
          p.tag_FR = "";
        }
      }
      p.clean_orig_price = p.orig_price; // need this for resetting

      if (!!p.certificate_needed && p.certificate_needed != "false") {
        p.certificate_needed = true;
      } else {
        p.certificate_needed = false; // this.cert_needed(p);
      }
      p.needs_logo = p.filters.indexOf("Gepersonaliseerde middelen") > -1;

      if (!!premium && !!p["partner_price_" + premium]) {
        let partner_price = p["partner_price_" + premium];
        p.partner_discount = p.base_price - partner_price;
        p.base_price = partner_price;
        if (!!p.price_from_unit_count && !!p.price_from_unit_count["1"]) {
          p.price_from_unit_count["1"] = p.base_price;
        }
        // never allow bulk pricing to be worse then the partner price
        for (let pr of p.price_from_unit_count) {
          if (pr > partner_price) pr = partner_price;
        }
      }

      // if( p.orig_price == p.base_price ) p.orig_price = undefined;

      p = this._translate_object(p);

      // TODO: make data format uniform (?)
      this._translate_attr(p, "categorie");
      this._translate_attr(p, "filter");
      if (!!p.filter && p.filters.indexOf(p.filter) < 0) {
        if (!p.filters) p.filters = [];
        try { p.filters.push(p.filter); } catch (e) { };
      }
      if (!!p.status && p.status.indexOf("EXPRESS") > -1) {
        this.express_shipping_product = p;
        p.is_special = false;
      }
      if (p.status === "ADMIN" || p.status === "REDEEM_POINT") {
        if (p.status === "ADMIN") {
          this.shipping_product = p;
          this.shipping_sku = p.id;
          this.shipping_costs = p.base_price;
          if (!!p.price_from_unit_count && p.price_from_unit_count["4"]) {
            this.pivot_point = p.price_from_unit_count["4"];
          } else {
            this.pivot_point = p.stock;
          }
        }
        if (p.status === "REDEEM_POINT") {
          this.redeem_point_product = p;
          this.redeem_point_sku = p.id;
          this.price_per_point = p.base_price;
          // p.unit_count = 25;
          p.max_units = 0;
          allowed.push(p);
        }
      } else {
        // ONLY show certified clients the special products or in super_order mode
        if (
          !p.certificate_needed ||
          !!this.remarks_by ||
          (!!this.user_info && this.user_info.is_certified)
        ) {
          if (p.needs_logo && !marketing_allowed) continue;
          if (p.is_special) {
            if (p.status != "FIRSTORDER_SPECIAL") allowed.unshift(p);
          } else {
            if (p.status != "DELETED") {
              if (p.status == "AVAILABLE" && p.base_price < 0) {
                // HIDE product with a NEGATIVE price
              } else {
                allowed.push(p);
              }
            }
          }
        }
      }
    }

    let sorted_allowed = allowed.sort((a, b) => {
      return b.order - a.order;
    });

    for (let s of top_specials) sorted_allowed.unshift(s);

    for (let p of sorted_allowed) {
      if (!!p.max_points_allowed && !!this.price_per_point) {
        p.max_points_allowed /= -this.price_per_point;
      }
    }
    if (this.max_order_count_1y && this.order_count_1y >= this.max_order_count_1y) {
      // expire ordering for all products 
      for (let ap of sorted_allowed) {
        ap.next_order_date = this.next_order_date;
        ap.max_units = -1;
      }
    }

    return sorted_allowed;
  }

  process_assets(alist) {
    // TODO: move this logic to asset page (?) 
    for (let p of alist) {
      if (Array.isArray(p.docs) && p.docs.length == 1) {
        // we expect just one URL not more an array ..
        p.docs = p.docs[0];
      }
      if (!p.filters) p.filters = [];
      p.is_asset = true;
      // TODO:  get the  asset properties in a more relaiable way
      // for now we look at the prefix of the products ID
      if (['BR', 'TR', 'BL', 'TL', 'NO'].indexOf(p.SKU) > -1) {
        // this is a KLEURPLAAT
        p.is_customizable = p.SKU != 'NO';
        p.has_preview = true; // requested by WvdL
        p.is_printable = true;
        p.is_downloadable = false;
      }
      if (p.SKU == "PDF" || p.SKU == 'NO') {
        // this is a PDF
        p.is_pdf = true;
        p.has_preview = true;
        p.is_printable = true;
        p.is_downloadable = true;
      }
      if (p.SKU == "MP4") {
        // this is a video
        p.is_video = true;
        p.has_preview = true;
        p.is_printable = false;
        p.is_downloadable = true;
      }
      if (["PNG", 'JPG', 'JPEG'].indexOf(p.SKU) > -1) {
        // this is a image
        p.is_image = true;
        p.has_preview = true;
        p.is_printable = false;
        p.is_downloadable = true;
      }
      p.needs_logo = p.filters.indexOf("Gepersonaliseerde middelen") > -1;
      p = this._translate_object(p);

      // filters and categories are NOT translates in the object but uses the translate mechanism
      // TODO: data should reflect this, now we have _NL attr in the database ?
      if (!p.categorie && !!p.categorie_NL) {
        p.categorie = p.categorie_NL;
      };
      if (!p.filter && !!p.filter_NL) {
        p.filter = p.filter_NL;
      };
      if (!!p.filter && p.filters.indexOf(p.filter) < 0) {
        p.filters.push(p.filter);
      }
    }

    let sorted_assets = alist.sort((a, b) => {
      return b.order - a.order;
    });

    return sorted_assets;
  }

  // TODO: this should become genericly available after testing the assets lib!
  // TODO: transparantly cache all resources
  get(resource: string) {
    let headers = new Headers({});

    if (!!this.subuser_info && !!this.subuser_info.parent) {
      headers.append("x-auth", this.subuser_info.parent);
    }

    if (!!this.subuser_info && !!this.subuser_info.token) {
      headers.append("authorization", "Bearer " + this.subuser_info.token);
    }
    let request_url = this.BASE_URL + "/api/" + this.NAMESPACE + "/" + resource;
    return this.http.get(request_url, { headers: headers });
  }

  find_product(sku) {
    if (!this.product_list_normal) {
      return undefined;
    }
    if (sku == "000") return this.shipping_product;
    for (const pr of this.product_list_normal) {
      if (pr.id == sku) return pr;
      // if( pr.SKU == sku ) return pr;
    }
    return undefined;
  }
  set_user(user) {
    this.user_info = { ...user }; // MAKE A COPY tp prevent data sticking in the dummy_user !!
    if (
      this.main_country === "DE" &&
      !!this.user_info &&
      !!this.user_info.country
    ) {
      const ship_to = this.user_info.country;
      if (
        !!this.shipping_product &&
        !!this.shipping_product["partner_price_" + ship_to]
      ) {
        this.shipping_costs = this.shipping_product["partner_price_" + ship_to];
      }
    }
  }

  get_assets() {
    // check cached versions first
    if (!!this.asset_list && this.asset_list.length > 0) {
      return Observable.of(this.asset_list);
    }
    // not  cached get from remote
    return this.get("asset").map((res) => {
      const data = res.json();
      // THIS is not needed dor assets ?
      const assets_available = this.process_assets(data);
      // cache for later user
      this.asset_list = assets_available;
      return assets_available;
    });
  }

  get_meetings() {
    // not  cached get from remote
    return this.get("meeting").map((res) => {
      const data = res.json();
      // THIS is not needed dor assets ?
      // cache for later user
      // this.asset_list = assets_available;
      return data;
    });
  }

  get_page_content(page_name) {
    // check cached versions first
    if (!!this.page_content) {
      return Observable.of(this.page_content[page_name]);
    }
    // not  cached get from remote
    return this.get("page").map((res) => {
      this.page_content = {};
      const data = res.json();
      // THIS is not needed dor assets ?
      // cache for later user
      for (const page of data) {
        this.page_content[page.id] = page;
        if (!!page.name) {
          this.page_content[page.name] = page;
        }
      }
      return this.page_content[page_name];
    });
  }


  getAllProducts(allow_first_order_special: boolean = false) {
    // check cached versions first
    if (allow_first_order_special) {
      if (
        !!this.product_list_first_order &&
        this.subuser_info &&
        !!this.subuser_info.token
      ) {
        return Observable.of(this.product_list_first_order);
      }
    } else {
      if (
        !!this.product_list_normal &&
        this.subuser_info &&
        !!this.subuser_info.token
      ) {
        return Observable.of(this.product_list_normal);
      }
    }

    return this.get("product").map((res) => {
      const data = res.json();
      const sorted_allowed = this.process_products(
        data,
        allow_first_order_special
      );
      // cache for later user
      if (allow_first_order_special) {
        this.product_list_first_order = sorted_allowed;
      } else {
        this.product_list_normal = sorted_allowed;
      }
      return sorted_allowed;
    });
  }

  getMyOrders(refresh?: boolean) {
    // check cache first
    if (!this.subuser_info) return Observable.of([]);

    if (!refresh && this.order_list) return Observable.of(this.order_list);

    return this.get("order")
      .map((res) => {
        const all_order_list = res.json();
        this.order_value_tot = 0;
        this.order_value_1y = 0;
        this.order_count_1y = 0;
        this.order_list = [];
        const now = Number(new Date());
        for (let o of all_order_list) {
          if (o.status === "CANCELED") continue;
          if (!!o.ext_id && o.ext_id.startsWith('None') && !!o.ordered_by) {
            o.ext_id = o.ext_id.replace('None', o.ordered_by);
          }
          if (!!o.sub_user && o.sub_user.email === this.subuser_info.email) {
            o.is_mine = true;
          } else {
            o.is_mine = false;
          }
          if (o.is_mine) {
            let o_tot = 0;
            for (const item of o.items) {
              if (item.product_details.status === 'ADMIN') continue;
              let pr = item.product_details.base_price;
              if (!!item.product_details.orig_price) {
                pr = item.product_details.orig_price;
              }
              o_tot += item.count * pr;
            }
            this.order_value_tot += o_tot;
            const order_age = now - Number(new Date(o.created));
            if (order_age < this.YEAR) {
              this.order_value_1y += o_tot;
              this.order_count_1y++;
              let new_next_order_date = now - order_age + this.YEAR;
              if (!this.next_order_date) {
                this.next_order_date = new_next_order_date;
              } else {
                this.next_order_date = Math.min(this.next_order_date, new_next_order_date);
              }
            }
            this.order_list.push(o);
          }
        }
        if (this.max_discount > 0 && this.max_order_value_1y) {
          this.max_discount = Math.min(this.max_discount, this.max_order_value_1y - this.order_value_1y);
          if (this.max_discount <= 0) {
            this.max_discount = 1; // NOTE: must be > 0 !
          }
        }
        return this.order_list;
      })
      .catch((err) => {
        return [];
      });
  }

  check_valid_email() {
    if (!!this.subuser_info) return true;
    if (this.send_order_email && !this.is_valid_email(this.new_user_email))
      return false;
    return true;
  }

  postOrder(email?: string) {
    if (
      !this.products_to_order ||
      (!!this.products_to_order.items &&
        this.products_to_order.items.length == 1 &&
        this.products_to_order.items[0].sku == this.shipping_sku)
    ) {
      // let remail = email.replace('@', '_at_').replace(/\./g, '_dot_');
      // email = remail + '@example.com';
      email = "noreply@example.com";
      this.products_to_order = {};
    }
    let allow_store_and_resend = true;
    let order = this.products_to_order || {};

    // make remark a complex object
    order.remark = {};
    if (this.subuser_info) {
      this.remarks_by =
        this.subuser_info.first_name + " " + this.subuser_info.last_name;
    }
    order.remark.am = this.remarks_by || "webshop";
    order.remark.demo = this.expo_demo;
    order.remark.optin = this.order_optin;
    order.remark.body = "";
    if (!!this.order_remark) {
      order.remark.body += this.order_remark;
    }
    if (!!this.add_marketing) {
      order.remark.body += "Please add free marketing materials to order.";
      order.remark.am = "client";
    }

    let order_url = this.BASE_URL + "/api/" + this.NAMESPACE + "/order";
    let headers = new Headers();
    if (!!this.subuser_info && !!this.subuser_info.parent) {
      headers.append("x-auth", this.subuser_info.parent);
    } else {
      if (!!this.user_info) {
        headers.append("x-auth", this.user_info.id);
      }
    }
    if (!!this.subuser_info && !!this.subuser_info.token) {
      headers.append("authorization", "Bearer " + this.subuser_info.token);
      allow_store_and_resend = false;
    } else {
      let parent_info =
        "NEW_COMP|NEW_ADDRESS|NEW_POSTCODE|NEW_CITY|NEW_COUNTRY|NEW_PHONE";
      if (!!this.user_info) {
        if (!!this.new_user_phone) {
          this.user_info.phone = this.new_user_phone;
        }
        if (!!this.user_info.ext_id) {
          // this is an existing parent !
          parent_info = ""; // `${this.user_info.ext_id}`;
        } else {
          parent_info = `${this.user_info.company}|${this.user_info.address}|${this.user_info.postalcode}|${this.user_info.city}|${this.user_info.country}|${this.user_info.phone}`;
        }
      }
      if (!email) {
        email = "anonymous_orders@belowenemylines.nl";
        this.new_user_firstname = "anonymous";
        this.new_user_lastname = "orders";
      }
      let user_info =
        "anonymous||" +
        email +
        "||" +
        this.new_user_firstname +
        "||" +
        this.new_user_lastname +
        "||" +
        parent_info;
      if (!!this.send_token_in_request) {
        order.user_info = user_info;
        headers.append("authorization", "Bearer user_info");
      } else {
        headers.append("authorization", "Bearer " + user_info);
      }
    }
    console.log(order);
    if (!allow_store_and_resend) {
      return this.http
        .post(order_url, JSON.stringify(order), {
          withCredentials: false,
          headers: headers,
        })
        .map((res) => res.json());
    } else {
      // store order locally
      const flat_headers = headers.toJSON();
      const local_order = {
        order: order,
        headers: flat_headers,
        status: "PENDING",
      };
      // start saving locally and remotely at the same time
      const remote_order_saved = this._resend_pending_order(local_order);
      const local_order_saved = Observable.fromPromise(
        this.local_db.orders.add(local_order)
      );

      return Observable.forkJoin([local_order_saved, remote_order_saved]).map(
        ([local_order_id, rem_order]) => {
          if (!!local_order_id && !!rem_order) {
            // it was saved to the server, so mark it locally
            this.local_db.orders
              .update(local_order_id, { status: rem_order.status })
              .then((updated) => { })
              .catch((error) => {
                console.warn(error);
              });
            this.count_orders();
            return rem_order; // may have status 'ERROR' but this just means we have to try again later
          }
        }
      );
    }
  }

  _resend_pending_order(local_order) {
    let order_url = this.BASE_URL + "/api/" + this.NAMESPACE + "/order";

    // reconstruct the http_headers ...
    let headers = new Headers({});

    let stored_headers = local_order.headers;
    for (const h in stored_headers) {
      headers.append(h, stored_headers[h]);
    }

    return this.http
      .post(order_url, JSON.stringify(local_order.order), {
        withCredentials: false,
        headers: headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((e) => {
        return Observable.of({ status: "ERROR" });
      });
  }


  post_new_user_request(user) {
    let user_url = this.BASE_URL + "/api/" + this.NAMESPACE + "/user_request"; // new
    let headers = new Headers({ 'content-type': 'appication/json' });
    if (!!this.LEAD_SRC && !user.link_source) {
      user.link_source = this.LEAD_SRC;
    }
    return this.http
      .post(user_url, JSON.stringify(user), { headers: headers })
      .map((res) => {
        return res.json();
      })
      .catch((e) => {
        return Observable.of({ status: "ERROR" });
      });
  }

  resend_pending_orders() {
    this.local_db.orders
      .where({ status: "ERROR" })
      .toArray()
      .then((pending_orders) => {
        for (const local_order of pending_orders) {
          this._resend_pending_order(local_order).subscribe((res) => {
            if (!!local_order.id) {
              this.local_db.orders
                .update(local_order.id, { status: res.status })
                .then()
                .catch();
            }
          });
        }
        this.count_orders();
      });
  }

  update_logo(image_data) {
    let user_url =
      this.BASE_URL +
      "/api/" +
      this.NAMESPACE +
      "/user/" +
      this.subuser_info.parent;
    let headers = new Headers({ "x-auth": this.subuser_info.parent });
    if (!!this.subuser_info && !!this.subuser_info.token) {
      headers.append("authorization", "Bearer " + this.subuser_info.token);
    }
    let parent = { marketing_logo: image_data, id: this.subuser_info.parent };
    return this.http
      .put(user_url, JSON.stringify(parent), {
        withCredentials: false,
        headers: headers,
      })
      .map((res) => res.json());
  }

  getCurrentUser() {
    return this.user_info;
  }

  format_price(cents_as_float) {
    const cents = Math.round(Number(cents_as_float));
    return (cents / 100.0); // we need a float not a string !?

    // if( cents == 0) return '0.00';
    // if( cents < 100 ) return '0.' + cents.toString();
    // return cents.toString().slice(0,-2) + '.' + cents.toString().slice(-2);

  }

  format_product(product, extra) { // for use in eddl events etc
    const prod_data = {
      ...extra,
      id: `${this.get_prx(product, 'ctn')}`,
      locale: this.current_language == 'fr' ? 'fr_BE' : 'nl_NL',
      price: this.format_price(product.base_price),
      originalPrice: this.format_price(product.orig_price),
      catalogType: 'PROFESSIONAL',
      grpCode: `${this.get_prx(product, 'grp')}`,
      catCode: `${this.get_prx(product, 'cat')}`,
      // subcatCode: 'HEALTHYWHITEPLUS_ORAL_CARE', // need to have this in out data ot het from PRX
      // stock: 0,
      // displayTypes: ['STOCK_RETAILER_ONLINE','NO_STOCK_NOTIFY_ME'],
      // marketPlaceParticipant: 'Philips'
    }
    return prod_data;
  }

  product_add_event(product, count, cart) {
    const eddlAction = {
      trigger: 'ecommerce.cart.add',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: this.currency,
        add: {
          // actionField: {list: 'recommended-products'},
          products: [this.format_product(product, { quantity: count })]
        },
        cart: {
          // id: '1234-5678-0987', // TODO: create uniq cart ID ?
          products: cart.map(pr => this.format_product(pr, { quantity: pr.order_amount }))
        }
      }
    };
    return this.trigger_event(eddlAction);
  }

  product_remove_event(product, count, cart) {
    const eddlAction = {
      trigger: 'ecommerce.cart.remove',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: this.currency,
        remove: {
          // actionField: {list: 'recommended-products'},
          products: [this.format_product(product, { quantity: count })]
        },
        cart: {
          // id: '1234-5678-0987', // TODO: create uniq cart ID ?
          products: cart.map(pr => this.format_product(pr, { quantity: pr.order_amount }))
        }
      }
    };
    return this.trigger_event(eddlAction);
  }

  show_cart_event(cart) {
    const eddlAction = {
      trigger: 'ecommerce.checkout.cartview',
      event: 'ecommerceEvent',
      // marketPlaceParticipant: 'complete-order', // ??
      marketPlaceParticipant: 'Philips',
      ecommerce: {
        currencyCode: this.currency,
        cart: {
          products: cart.map(pr => this.format_product(pr, { quantity: pr.order_amount }))
        }
      }
    };
    return this.trigger_event(eddlAction);
  }

  confirm_order_event(cart, order_data) {
    const eddlAction = {
      trigger: 'ecommerce.checkout.purchase',
      event: 'ecommerceEvent',
      marketPlaceParticipant: 'Philips',
      ecommerce: {
        currencyCode: this.currency,
        purchase: {
          actionField: {
            id: `${order_data.id}`,
            revenue: this.format_price(order_data.revenue),
            tax: this.format_price(order_data.tax),
            shipping: this.format_price(order_data.shipping),
            discount: this.format_price(order_data.discount),
            // coupon: '{{orderCoupon}}'
          },
          products: cart.map(pr => this.format_product(pr, { quantity: pr.order_amount }))
        }
      }
    };
    return this.trigger_event(eddlAction);
  }

  get_prx(product, attr) {
    if (product.PRX) {
      // of we have PRX data we use it
      return product.PRX[attr];
    } else {
      // try to guess the CTN
      if (attr == 'ctn' && !!product.ext_id && product.ext_id.toString().includes('/')) return product.ext_id;
      if (attr == 'ctn' && !!product.SKU && product.SKU.toString().includes('/')) return product.SKU;
      if (attr == 'ctn' && !!product.id && product.id.toString().includes('/')) return product.id;
    }
    return null;
  }

  product_detail_event(product) {

    const prx_url = `https://www.philips.nl/prx/product/B2C/nl_NL/CONSUMER/products/${product.id}.summary`;

    const eddlAction = {
      trigger: 'ecommerce.product.detail',
      event: 'ecommerceEvent',
      marketPlaceParticipant: 'Philips',
      ecommerce: {
        currencyCode: this.currency,
        detail: {
          products: [this.format_product(product, {})]
        }
      }
    }
    return this.trigger_event(eddlAction);
  }

  virtual_pageview(path) {
    const eddlAction = {
      trigger: 'event.philipsdentalcarecom.navigation',
      event: 'pageEvent',
      interaction: {
        goal: 'virtual_pageview',
        description: path == '/' ? 'HOME' : path.split('/').slice(-1)[0],
        url: path,
        interactive: true, // ??
      },
    };
    return this.trigger_event(eddlAction);
  }

  trigger_event(eddlAction) {
    console.debug(eddlAction);
    if (!eddlAction) return;
    if (!window['trigger_event']) return;
    try {
      window['trigger_event'](eddlAction);
    } catch (e) {
      console.warn(e);
    };
  }

  presentMessage(message, mess_type?, timeout?) {
    // TODO: add extra param for type
    if (!mess_type) mess_type = "success";
    if (timeout == undefined) timeout = 5500;
    const toast: Toast = {
      type: mess_type,
      title: this.translate.instant(mess_type),
      body: this.translate.instant(message),
      timeout: timeout,
      showCloseButton: true,
    };
    this.toasterService.pop(toast);

    // this.toasterService.pop(mess_type, this.translate.instant(mess_type), this.translate.instant(message));
  }

  // Global functions

  adjust_date_object(item) {
    if (!!item && !!item.created) {
      if (item.created.indexOf("T") == -1) {
        item.created_datetime = new Date(item.created.replace(/\-/g, "/"));
      } else {
        item.created_datetime = new Date(item.created);
      }
    }
    if (!!item && !!item.updated) {
      if (item.updated.indexOf("T") == -1) {
        item.updated_datetime = new Date(item.updated.replace(/\-/g, "/"));
      } else {
        item.updated_datetime = new Date(item.updated);
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/data.service.ts